import * as React from 'react';
import { ButtonSize } from '../Button/ButtonSize.csharp';
import { ButtonTier } from '../Button/ButtonTier.csharp';
import { Link } from '../Link/Link';
import { LinkType } from '../Link/LinkType.csharp';
import type { LinkViewModel } from '../Link/LinkViewModel.csharp';
import { List } from '../List/List';
import { PersonInfo } from '../PersonInfo/PersonInfo';
import type { PersonInfoViewModel } from '../PersonInfo/PersonInfoViewModel.csharp';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import styles from './PersonInfoList.module.css';

interface PersonInfoListProps {
    persons: PersonInfoViewModel[];
    title?: string;
    link?: LinkViewModel;
}

export const PersonInfoList: React.FC<React.PropsWithChildren<PersonInfoListProps>> = props => {
    const { title, persons, link } = props;

    return (
        <div className={styles.PersonInfoList}>
            <div className={styles.Inner}>
                <div className={styles.Heading}>
                    {title && <h2 className={styles.Title}>{title}</h2>}
                    {link && (
                        <Link
                            {...link}
                            type={LinkType.Button}
                            buttonSize={ButtonSize.Medium}
                            buttonTier={ButtonTier.Primary}
                            showIsExternal={false}
                            className={styles.Link}
                        >
                            <span>{link.label}</span>
                            <SvgIcon iconName="arrow-right" />
                        </Link>
                    )}
                </div>
                <List
                    className={styles.List}
                    items={persons}
                    renderItem={(item, index) => (
                        <li className={styles.ListItem} key={index}>
                            <PersonInfo {...item} />
                        </li>
                    )}
                />
            </div>
        </div>
    );
};
